import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';

class General extends Component {
    render() {
        return (
            <div className="General">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <PresetColorPicker
                            color={this.props.fontData.backgroundColor}
                            onColorChange={this.props.onGeneralBackgroundColorChange(this.props.tagName)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

General.propTypes = {
    tagNameName: PropTypes.string
};

General.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    return { ...state.app.data.theme.filterBar[ownProps.tagName], ...state.theme.filterBar };
};

const mapDispatchToProps = dispatch => {
    return {
        onGeneralBackgroundColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_GENERAL_BACKGROUND_COLOR,
                    layer: tagName,
                    backgroundColor: event.target.value
                });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(General);



// WEBPACK FOOTER //
// ./src/components/pages/theme/filterbar/General.js